
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React, { Component } from "react";
import banner from '../pics/banner.PNG';
import Select from 'react-select';
import About from '../About/About';
import { FaWhatsapp, FaSearch } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getCustomerOrders, getAllCustomerOrders, getAllOrderStatuses, formatDate } from '../Utils/Utils';
import { Ordertable } from '../Customerordertable/Customerordertable';
import { LayoutDashboard, Menu } from 'lucide-react';
import { LoadingPage } from '../Loadingpage/Loadingpage';
class Trackorder extends React.Component {
    constructor(props) {
        super(props);
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            servicedate: new Date(),
            mycomments: '',
            loadweights: '',
            mobilePhone: '',
            address: '',
            totalamount: '0.00',
            shouldRedirect: false,
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            token: "",
            role: "",
            address: "",
            city: "",
            area: "",
            userid: "",
            gender: "",
            customerOrders: [],
            allCustomerOrders: [],
            allorderstatuses: [],
            orderCount: 0,
            page: 'trackOrders',
            isLoading: true,
            searchTerm: '',
            userstatus: '',
            registrationdate: ''
        }
    }
    componentDidMount = async () => {
        let strOrders = await getCustomerOrders(this.props.location.state.userid);
        this.setState({ isLoading: false });
        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city,
                userid: this.props.location.state.userid, gender: this.props.location.state.gender, userstatus: this.props.location.state.userstatus, registrationdate: this.props.location.state.registrationdate,
                customerOrders: await getCustomerOrders(this.props.location.state.userid),
                allCustomerOrders: await getAllCustomerOrders(), allorderstatuses: await getAllOrderStatuses()
            })

            if (strOrders.includes('no data')) {
                this.setState({ orderCount: 0 });
            }
            else {
                this.setState({ orderCount: strOrders.length });
            }
            //  console.log(strOrders);
        }
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    getLastOrderStatus = (orderid) => {
        let lastStatus = 'Submitted'
        if ((Array.isArray(this.state.allorderstatuses)) && (this.state.allorderstatuses.length !== 0)) {
            for (let i = 0; i < this.state.allorderstatuses.length; i++) {
                if (this.state.allorderstatuses[i].orderid === orderid) {
                    lastStatus = this.state.allorderstatuses[i].status
                    break
                }
            }
            //  console.log(this.state.allorderstatuses)                        
        }
        return lastStatus
    }
    setSearchTerm = (e) => {

        if (e.target.value.trimEnd() === '' || e.target.value.trimStart() === '') {
            this.componentDidMount();
            return;
        }
        let input = e.target.value.replace(/\D/g, ''); // Remove all non-digits    
        // Apply mask: Group into 4 digits separated by spaces
        const dateMasked = input
        let year = dateMasked.slice(0, 4)
        let month = dateMasked.slice(4, 6)
        let day = dateMasked.slice(6, 8)
        const strDate = year + '-' + month + '-' + day

        if (strDate.length === 10) {
            const searchResult = this.state.customerOrders.filter(order => {
                return ((order.modified).slice(0, 10)).includes(strDate)
            });
            this.setState({ searchTerm: e.target.value, customerOrders: searchResult });
        }
    }

    clearSearchTerm = (e) => {
        if (e.key === 'Backspace' && this.state.searchTerm.length === 1) {
            this.setState({ searchTerm: '' });
            this.componentDidMount();
        }
    }
    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, gender: this.props.location.state.gender,
                phonenumber: this.props.location.state.phonenumber, role: this.props.location.state.role, address:
                    this.props.location.state.address, area: this.props.location.state.area, city: this.props.location.state.city, userid: this.props.location.state.userid,
                userstatus: this.props.location.state.userstatus, registrationdate: this.props.location.state.registrationdate
            }
        });
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }
        // console.log(this.props.location.state);
        return (
            <>
                <div style={{ height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px", fontFamily: "lora" }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid #f0eee4', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{ paddingTop: "10px", paddingBottom: "5px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold", textShadow: "2px 2px 4px #000000" }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            <span style={{ fontStyle: "italic" }}><label>Logged in as {(this.state.fullname).split(" ")[0]} </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span> */}
                        </div>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "1vh", fontSize: "18px" }}>
                        <span variant="primary" style={{
                            border: "none", width: "200px",
                            paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "100%", borderRadius: "10px"
                        }} onClick={this.goBackToMenu}>
                            <label style={{
                                textAlign: "center", fontStyle: "italic", color: "darkblue",
                                fontWeight: "bold", textShadow: "1px 1px 2px grey", fontSize: "18px"
                            }}><ArrowLeft color="darkblue" size={40} />TRACK MY ORDER</label>
                        </span>
                    </div>
                    {this.state.isLoading ? (
                        <LoadingPage />
                    ) : (
                        <>
                            <div style={{ paddingTop: "10px", fontSize: "18px" }}>
                                <FormGroup>
                                    <FaSearch size={20} style={{ position: "absolute", marginLeft: "85%", marginTop: "10px" }} />
                                    <Input
                                        style={{backgroundColor: "#f0eee4", height: '50px', borderBottom: "2px solid darkblue", borderRadius: "10px", fontStyle: "italic", }}
                                        type='date'
                                        mask="YYYY-MM-DD"
                                        size={10}
                                        id='searchOrders'
                                        placeholder='Search by submitted date YYYYMMDD'
                                        onChange={this.setSearchTerm}
                                        onKeyDown={this.clearSearchTerm}
                                    />
                                </FormGroup>
                            </div>
                            <div style={{ paddingBottom: "10px", overflow: "auto", fontSize: "18px" }}>
                                <div style={{ paddingTop: "10px", paddingBottom: "5px" }}>
                                    <span className="" style={{ color: "darkblue", fontStyle: "italic" }}><h5>My Orders: {this.state.orderCount}</h5></span>
                                </div>
                                <div style={{ border: "1px solid #ccc", borderRadius: "10px", paddingbottom: "10px" }}>
                                    {/* Call the new component here */}
                                    <Ordertable data={this.state.customerOrders}
                                        laststatus={this.getLastOrderStatus}
                                        navigation={(orderid) => this.props.navigate('/orderdetails', {
                                            state: {
                                                orderid: orderid, fullname: this.state.fullname, emailaddress: this.state.emailaddress,
                                                userid: this.state.userid, phonenumber: this.state.phonenumber, role: this.state.role, address:
                                                    this.state.address, area: this.state.area, city: this.state.city, page: this.state.page, gender: this.state.gender,
                                                userstatus: this.state.userstatus, registrationdate: this.state.registrationdate
                                            }
                                        })} />
                                </div>
                            </div>
                        </>)
                    }

                    <div className="footer-content" style={{
                        borderTop: "10px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                        backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "10px", paddingBottom: "10px"
                    }}>
                        <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                        <div className="footer-links">
                            <Button style={{
                                backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                fontWeight: "bold", textDecoration: "underline"
                            }}
                                onClick={this.openAbout}>About Us
                            </Button>
                            | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>

                        </div>
                    </div>
                    <div>
                        <About
                            ref={this.handleAboutOpen}
                            onAboutClose={this.onAboutClose}
                        />
                    </div>
                </div>
            </>
        );
    }
}
export default withNavigateHook(Trackorder);
